import { Skeleton } from "components/src/components/Skeleton/Skeleton";
import { sizeMap } from "./_NavItemStacked";
export const NavItemStackedSkeleton = ({size}) => {
    return <div className="cui-min-w-[32px] cui-w-full cui-max-w-[90px] cui-flex cui-flex-col cui-gap-sm">
        <Skeleton width={sizeMap[size]} height={sizeMap[size]} rounded="full"/>
        <Skeleton width={sizeMap[size]} height={sizeMap[size]/2} />
    </div>
}